export default "__VITE_ASSET__qWGEH53F__"